import { configureStore } from "@reduxjs/toolkit";
import partsConfigurationReducer from "./features/configuration/parts/partsConfigurationSlice";
import timeControlsReducer from "./features/configuration/parts/TimeControlsSlice";
import tabReducer from "./features/TabsManager/tabSlice";
import sitesSlice from "./features/configuration/locations/locationsSitesSlice";
import internalRepairReducer from "./features/configuration/parts/internalRepairSlice";
import vendorCostSlice from "./features/configuration/parts/vendorCostSlice";
import effectivitySlice from "./features/configuration/parts/effectivitySlice";
import packageIntakeReducer  from "./features/StoresModule/packageIntakeSlice";
import VendorApprovalReducer from "./features/VendorModule/VendorApproval/VendorApprovalSlice";
import VendorAwbReducer from "./features/VendorModule/VendorAwb/VendorAwbSlice";
import VendorDiscrepancyReducer from "./features/VendorModule/VendorDiscrepancy/VendorDiscrepancy";
import quoteEntryReducer from "./features/quoteEntry/quoteEntrySlice";
import { homeDashboardReducer } from "./features/dashboards/homeDashboardSlice";
import { configurationDashboardReducer } from "./features/dashboards/configurationDashboardSlice";
import { supplyChainDashboardReducer } from "./features/dashboards/supplyChainDashboardSlice";
import { storeDashboardReducer } from "./features/dashboards/storeDashboardSlice";
import { vendorDashboardReducer } from "./features/dashboards/vendorDashboardSlice";
import { accountReducer } from "./features/account/accountSlice";
import { loaderReducer } from "./features/loader/loaderSlice";
import nlaReceivingSliceReducer from "./features/StoresModule/nlaReceivingSlice"

export default configureStore({
  reducer: {
    partsConfiguration: partsConfigurationReducer,
    locationSites: sitesSlice,
    timeControls: timeControlsReducer,
    tabs: tabReducer,
    vendorCost: vendorCostSlice,
    internalRepair: internalRepairReducer,
    effectivity: effectivitySlice,
    packageIntake: packageIntakeReducer,
    vendorAwb: VendorAwbReducer,
    vendorApproval: VendorApprovalReducer,
    quoteEntry: quoteEntryReducer,
    homeDashboard: homeDashboardReducer,
    configurationDashboard: configurationDashboardReducer,
    supplyChainDashboard: supplyChainDashboardReducer,
    storeDashboard: storeDashboardReducer,
    vendorDashboard: vendorDashboardReducer,
    account: accountReducer,
    loader: loaderReducer,
    vendorDiscrepancy: VendorDiscrepancyReducer,
    receivingNla : nlaReceivingSliceReducer
  },
});
